export enum ResponseState {
    SUCCESS,
    FAILURE
}